// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS
export const FETCH_PRINTING_DC_DETAILS_REQUEST = 'FETCH_PRINTING_DC_DETAILS_REQUEST';
export const FETCH_PRINTING_DC_DETAILS_SUCCESS = 'FETCH_PRINTING_DC_DETAILS_SUCCESS';
export const FETCH_PRINTING_DC_DETAILS_FAILURE = 'FETCH_PRINTING_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_REQUEST';
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_SUCCESS';
export const FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE = 'FETCH_PRINTING_DC_DETAILS_PROGRAM_FAILURE';

// FETCH ALL PROPERTIES FROM PRINTING_DC DETAILS BY ID
export const FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_PRINTING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_PRINTING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_PRINTING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_PRINTING_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR PRINTING_DC DETAILS
export const CREATE_PRINTING_DC_DETAILS_REQUEST = 'CREATE_PRINTING_DC_DETAILS_REQUEST';
export const CREATE_PRINTING_DC_DETAILS_SUCCESS = 'CREATE_PRINTING_DC_DETAILS_SUCCESS';
export const CREATE_PRINTING_DC_DETAILS_FAILURE = 'CREATE_PRINTING_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_PRINTING_DC_DETAILS = 'CREATE_USER_FORM_PRINTING_DC_DETAILS';

// UPDATE PROPERTIES FOR PRINTING_DC DETAILS
export const UPDATE_PRINTING_DC_DETAILS_REQUEST = 'UPDATE_PRINTING_DC_DETAILS_REQUEST';
export const UPDATE_PRINTING_DC_DETAILS_SUCCESS = 'UPDATE_PRINTING_DC_DETAILS_SUCCESS';
export const UPDATE_PRINTING_DC_DETAILS_FAILURE = 'UPDATE_PRINTING_DC_DETAILS_FAILURE';

// FETCH SINGLE PRINTING_DC_DETAILS
export const FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_PRINTING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_PRINTING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_PRINTING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR PRINTING_DC DETAILS
export const DELETE_PRINTING_DC_DETAILS_REQUEST = 'DELETE_PRINTING_DC_DETAILS_REQUEST';
export const DELETE_PRINTING_DC_DETAILS_SUCCESS = 'DELETE_PRINTING_DC_DETAILS_SUCCESS';
export const DELETE_PRINTING_DC_DETAILS_FAILURE = 'DELETE_PRINTING_DC_DETAILS_FAILURE';

// USERFORM RESET

export const PRINTING_DC_DETAILS_USERFORM_RESET = 'PRINTING_DC_DETAILS_USERFORM_RESET';

//DCNO
export const FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_PRINTING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_PRINTING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_PRINTING_DC_DETAILS_DC_NO_FAILURE';

//GRN NO
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_REQUEST';
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_SUCCESS';
export const FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE = 'FETCH_GRN_NO_BY_PRINTING_DC_NO_FAILURE';

export const CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_PRINTING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK';

//CREATE USER FORM

export const CREATE_USER_FORM_PRINTING_DC_EDIT_QTY_DK = 'CREATE_USER_FORM_PRINTING_DC_EDIT_QTY_DK';

export const RESET_PRINTING_DC_EDIT_QTY_DK = 'RESET_PRINTING_DC_EDIT_QTY_DK';

export const FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM PRINTING_PART_DC DETAILS
export const FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_REQUEST = 'FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_REQUEST';
export const FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_SUCCESS = 'FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_SUCCESS';
export const FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_FAILURE = 'FETCH_PRINTING_PART_DC_DETAILS_FIRST_GRID_FAILURE';

// FETCH ALL PROPERTIES FROM PRINTING_PART_DC DETAILS
export const FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_REQUEST = 'FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_REQUEST';
export const FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_SUCCESS = 'FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_SUCCESS';
export const FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_FAILURE = 'FETCH_PRINTING_PART_DC_DETAILS_SECOND_GRID_FAILURE';

export const PRINTING_PART_DC_DETAILS_USERFORM_RESET = 'PRINTING_PART_DC_DETAILS_USERFORM_RESET';

export const CREATE_USER_FORM_PRINTING_PART_DC_EDIT_QTY = 'CREATE_USER_FORM_PRINTING_PART_DC_EDIT_QTY';
export const CREATE_USER_FORM_PRINTING_PART_DC_SECOND_GRID_EDIT_QTY = 'CREATE_USER_FORM_PRINTING_PART_DC_SECOND_GRID_EDIT_QTY';

export const RESET_PRINTING_PART_DC_EDIT_QTY_V2 = 'RESET_PRINTING_PART_DC_EDIT_QTY_V2';
export const RESET_PRINTING_PART_DC_SECOND_GRIG_EDIT_QTY_V2 = 'RESET_PRINTING_PART_DC_SECOND_GRIG_EDIT_QTY_V2';

// CREATE PROPERTIES FOR PRINTING_PART_DC DETAILS
export const CREATE_PRINTING_PART_DC_DETAILS2_REQUEST = 'CREATE_PRINTING_PART_DC_DETAILS2_REQUEST';
export const CREATE_PRINTING_PART_DC_DETAILS2_SUCCESS = 'CREATE_PRINTING_PART_DC_DETAILS2_SUCCESS';
export const CREATE_PRINTING_PART_DC_DETAILS2_FAILURE = 'CREATE_PRINTING_PART_DC_DETAILS2_FAILURE';


export const PRINTING_PART_PROGRAM_ID_REQUEST = 'PRINTING_PART_PROGRAM_ID_REQUEST';
export const PRINTING_PART_PROGRAM_ID_SUCCESS = 'PRINTING_PART_PROGRAM_ID_SUCCESS';
export const PRINTING_PART_PROGRAM_ID_FALIURE = 'PRINTING_PART_PROGRAM_ID_FALIURE';


export const FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_REQUEST = 'FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_REQUEST';
export const FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_SUCCESS = 'FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_SUCCESS';
export const FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_FAILURE = 'FETCH_PRINTING_DC_DETAILS_APPROVAL_STATUS_FAILURE';

export const FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_REQUEST = 'FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_REQUEST';
export const FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_SUCCESS = 'FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_SUCCESS';
export const FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_FAILURE = 'FETCH_PRINTING_DC_STITCHED_PREVIOUS_LIST_FAILURE';

export const FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_IS_PART_PRINTING_DC_PREVIOUS_LIST_FAILURE';

export const PRINTING_DC_WITH_BUNDLE_GET_REQUEST = 'PRINTING_DC_WITH_BUNDLE_GET_REQUEST';
export const PRINTING_DC_WITH_BUNDLE_GET_SUCCESS = 'PRINTING_DC_WITH_BUNDLE_GET_SUCCESSS';
export const PRINTING_DC_WITH_BUNDLE_GET_FAILURE = 'PRINTING_DC_WITH_BUNDLE_GET_FAILURE';

export const CREATE_USER_FORM_PRINTING_DC_GENERATE_QTY = ' CREATE_USER_FORM_PRINTING_DC_GENERATE_QTY';

export const UPDATE_PRINTING_BUNDLE_FILTER_INITIAL = 'UPDATE_PRINTING_BUNDLE_FILTER_INITIAL';

export const PRINTING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE = 'PRINTING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE';

export const PRINTING_DC_WITH_BUNDLE_POST_REQUEST = 'PRINTING_DC_WITH_BUNDLE_POST_REQUEST';
export const PRINTING_DC_WITH_BUNDLE_POST_SUCCESS = 'PRINTING_DC_WITH_BUNDLE_POST_SUCCESS';
export const PRINTING_DC_WITH_BUNDLE_POST_FAILURE = 'PRINTING_DC_WITH_BUNDLE_POST_FAILURE';

export const PRINTING_DC_WITH_BUNDLE_POST_GET_REQUEST = 'PRINTING_DC_WITH_BUNDLE_POST_GET_REQUEST';
export const PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS = 'PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS';
export const PRINTING_DC_WITH_BUNDLE_POST_GET_FAILURE = 'PRINTING_DC_WITH_BUNDLE_POST_GET_FAILURE';

export const PRINTING_WITH_BUNDLE_RESET_DATA = 'PRINTING_WITH_BUNDLE_RESET_DATA'

export const PRINTING_OIL_ADAS_ALLOWED_QTY_GET_REQUEST = 'PRINTING_OIL_ADAS_ALLOWED_QTY_GET_REQUEST';
export const PRINTING_OIL_ADAS_ALLOWED_QTY_GET_SUCCESS = 'PRINTING_OIL_ADAS_ALLOWED_QTY_GET_SUCCESS';
export const PRINTING_OIL_ADAS_ALLOWED_QTY_GET_FAILURE = 'PRINTING_OIL_ADAS_ALLOWED_QTY_GET_FAILURE';